import React from "react";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardMetrics from "../../components/Metrics/metrics";
import { analyticsMetrics, sampleData, statusOption } from "../../utils/mock";
import RevenueExpensesChart from "../../components/pages/Analysis/RevenueExpenseChart";
import RevenueExpensesPieChart from "../../components/pages/Analysis/TransactionPieChart";
import { FinancialTrendLineChart } from "../../components/pages/Analysis/FinancialTrendChart";
import FleetrifyCard from "../../components/Card";
import { FleetrifyTabs } from "../../components/Tabs/tabs";
import { useAnalysisControllers } from "../../controllers/useAnalysisControllers";
import AnalysisTable from "../../components/Table/AnalysisTable";
import FleetrifyFilter from "../../components/Filter/filter";

const Analysis = () => {
  const { activeTab, filter, tabsData, handleTabChange, handleFilterChange } =
    useAnalysisControllers();
  const { search, status, transactionType, paymentMethod } = filter;
  return (
    <DashboardLayout title="Analysis" containerClass="space-y-10">
      <DashboardMetrics metrics={analyticsMetrics.metrics} />
      <FleetrifyCard cardContainerClass="w-full h-full space-y-10">
        <div className="flex">
          <FleetrifyTabs
            items={tabsData}
            defaultValue="chart"
            onChange={handleTabChange}
            tabItemClassName="px-4 py-2"
            activeTabItemClassName="font-bold text-white"
            inactiveTabItemClassName="text-gray-500 hover:text-[#143887]"
          />
        </div>
        {activeTab === "chart" && (
          <>
            <div className="grid grid-cols-2 gap-6 w-full h-full">
              <div className="w-full h-full mt-4">
                <RevenueExpensesChart />
              </div>
              <div className="w-full h-full mt-4">
                <RevenueExpensesPieChart />
              </div>
            </div>
            <div className="mt-4">
              <FinancialTrendLineChart data={sampleData} />
            </div>
          </>
        )}
        {activeTab === "table" && (
          <div className="relative">
            <AnalysisTable
              renderLeftContent={
                <FleetrifyFilter
                  searchInputClass="!bg-[#F5F6FA]"
                  selectWrapClass="!bg-[#F5F6FA]"
                  searchValue={search}
                  onSearchChange={(value) =>
                    handleFilterChange("search", value)
                  }
                  statusOption={statusOption}
                  onStatusChange={(value: any) =>
                    handleFilterChange("status", value)
                  }
                  statusValue={status}
                  transactValue={transactionType}
                  transactOption={[]}
                  onTransactChange={(value: any) =>
                    handleFilterChange("transactionType", value)
                  }
                  paymentValue={paymentMethod}
                  paymentOption={[]}
                  onPaymentChange={(value: any) =>
                    handleFilterChange("paymentMethod", value)
                  }
                />
              }
            />
          </div>
        )}
      </FleetrifyCard>
    </DashboardLayout>
  );
};

export default Analysis;
